module.exports = __webpack_public_path__ + "img/Group.25071f1f.png";